<template>
  <div class="dimed wrap">
    <div class="layer layer--nobutton">
      <div class="layer__header">
        <div class="lyr-title">{{ $t('Modal.PayComplete.msg1') }}</div>
        <div class="ft-error">{{ $t('Modal.PayComplete.msg2') }}</div>
      </div>
      <div class="layer__body" @click="clickEnd">
        <img src="@/assets/images/user/img-info12.png" alt="" />
        <div class="info-area2">
          <div class="lyr-txt">{{ $displayUprc(tranObj.totalUprc) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'payComplete',
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
      currUnitText: this.$store.getters.getCurrUnitText,
      orderType: this.$store.getters.getPosConfig.posConfig.templateNo,
      setTime: null,
    };
  },
  props: {
    tranObj: Object,
  },
  methods: {
    payComplete() {
      if (this.orderType == 'F') {
        this.$emit('setWineStage', JSON.stringify(this.tranObj));
      } else {
        this.$router.replace({name: 'bell-select', params: {tran: JSON.stringify(this.tranObj)}});
      }
    },
    clickEnd() {
      clearTimeout(this.setTime);
      this.payComplete();
    },
  },
  mounted() {
    this.setTime = setTimeout(() => {
      this.payComplete();
    }, 5000);
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
};
</script>

<style src='@/assets/css/user/common.css' scoped></style>
<style src="@/assets/css/user/pages/keypad.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/keypad-dark.css" scoped></style>
<!-- HSSHIN 20230413 임시로 스타일 고정 -->
<style scoped>
.lyr-txt,
.dark .lyr-txt {
  font-size: 2.8em;
  font-weight: 900;
}
</style>
